import { MinusButton } from "@/components/Buttons/MinusButton";
import { PlusButton } from "@/components/Buttons/PlusButton";
import type React from "react";
import { useState } from "react";

interface PriceSelectionCardProps {
  yen: string;
  totalYen: number;
  onYenChange: (yen: number, quantity: number) => void;
  maxYen: number;
  initialQuantity?: number;
}

export const PriceSelectionCard: React.FC<PriceSelectionCardProps> = ({
  yen,
  totalYen,
  onYenChange,
  maxYen,
  initialQuantity = 0,
}) => {
  const [isSelected, setIsSelected] = useState(initialQuantity > 0);
  const [quantity, setQuantity] = useState<number>(initialQuantity);
  const canAddMore = totalYen + Number(yen) <= maxYen;

  const handleClick = () => {
    if (!isSelected && canAddMore) {
      setIsSelected(true);
      setQuantity(1);
      onYenChange(Number(yen), 1);
    }
  };

  const handleMinusClick = () => {
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      if (newQuantity === 0) {
        setIsSelected(false);
      }
      onYenChange(Number(yen), newQuantity);
    }
  };

  const handlePlusClick = () => {
    const newQuantity = quantity + 1;
    const newTotal = totalYen + Number(yen);
    if (newTotal <= maxYen) {
      setQuantity(newQuantity);
      onYenChange(Number(yen), newQuantity);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div
        className={`col-span-1 border border-solid ${isSelected ? "border-primary bg-[#EFF9FF]" : "border-disabled bg-white"} py-3 px-5 rounded-md cursor-pointer`}
        onClick={handleClick}
      >
        <div className="flex flex-col items-start">
          <p className={`text-[22px] font-bold ${isSelected ? "text-black" : "text-gray"}`}>
            {Number(yen).toLocaleString()}円分
          </p>
        </div>
      </div>
      {isSelected && (
        <div className="col-span-1 flex items-center justify-center gap-[9px]">
          <p className="text-xs font-medium">交換件数</p>
          <MinusButton onClick={handleMinusClick} />
          <p className="text-base font-medium">{quantity}</p>
          {canAddMore && <PlusButton onClick={handlePlusClick} />}
        </div>
      )}
    </div>
  );
};
